import { baseGeospatial } from "../../../../api/base/baseUrl";

const BASE_URL = "/api/v1/geography-catalog/departments";

export async function getDepartmentListRequest() {
  const response = await baseGeospatial.get(`${BASE_URL}/get-all-list`);
  return response.data;
}

export async function getDepartmentListByCountryIdRequest(countryId) {
  const response = await baseGeospatial.get(
    `${BASE_URL}/get-by-countryid/${countryId}`,
  );
  return response.data;
}

export async function getDepartmentByIdRequest(id) {
  const response = await baseGeospatial.get(`${BASE_URL}/get-by-id/${id}`);
  return response.data;
}

export async function createDepartmentRequest(payload) {
  const response = await baseGeospatial.post(BASE_URL, payload);
  return response.data;
}

export async function updateDepartmentRequest(payload) {
  const response = await baseGeospatial.put(`${BASE_URL}/update`, payload);
  return response.data;
}
